import axios from 'axios';

const token = localStorage.getItem('token');

export default axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v1/`,
    headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});


// WEBPACK FOOTER //
// ./src/api/api.js